import type { RowFilters } from "@/services/tax-closing";

export const SITUATION_ALL = "Todos";
export const SITUATION_DEFAULT = "Autorizada";
export const SITUATION_FILTER_LABEL = "Situação do documento";
export const SITUATION_QUERY_KEY = "situation";

export function situationToFilters(situation: string): RowFilters {
  if (situation === SITUATION_ALL) return {};
  return { situacao: [situation] };
}

export function buildSituationOptions(situations: readonly string[]): string[] {
  return [SITUATION_ALL, ...situations];
}

export function shouldFallbackToAll(
  situation: string,
  situations: readonly string[],
): boolean {
  return situation !== SITUATION_ALL && !situations.includes(situation);
}
